import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { LineChart, Line, ResponsiveContainer, XAxis, YAxis, Tooltip, RadarChart, PolarGrid, PolarAngleAxis, Radar } from "recharts";

export default function Performance() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/student/performance").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="py-20 text-center text-content-muted">Loading…</div>;
  return (
    <div className="space-y-8">
      <h1 className="font-heading text-2xl font-bold">Performance</h1>
      <div className="card-surface p-5">
        <h3 className="font-heading font-semibold text-sm mb-4">Score & accuracy over time</h3>
        {d.trend.length ? (
          <ResponsiveContainer width="100%" height={260}>
            <LineChart data={d.trend}>
              <XAxis dataKey="name" stroke="#64748B" fontSize={10} tickLine={false} />
              <YAxis stroke="#64748B" fontSize={10} tickLine={false} />
              <Tooltip contentStyle={{ background: "#151F30", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, fontSize: 12 }} />
              <Line type="monotone" dataKey="score" stroke="#F97316" strokeWidth={2} name="Score %" dot={{ r: 3 }} />
              <Line type="monotone" dataKey="accuracy" stroke="#10B981" strokeWidth={2} name="Accuracy %" dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        ) : <div className="h-[260px] flex items-center justify-center text-sm text-content-muted">Attempt tests to see analytics.</div>}
      </div>
      {d.subject_accuracy.length > 0 && (
        <div className="card-surface p-5">
          <h3 className="font-heading font-semibold text-sm mb-4">Subject-wise accuracy</h3>
          <ResponsiveContainer width="100%" height={300}>
            <RadarChart data={d.subject_accuracy}>
              <PolarGrid stroke="rgba(255,255,255,0.1)" />
              <PolarAngleAxis dataKey="subject" tick={{ fill: "#94A3B8", fontSize: 11 }} />
              <Radar dataKey="accuracy" stroke="#F97316" fill="#F97316" fillOpacity={0.35} />
            </RadarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
